import { Dispatch } from 'redux'

import { useThunkActions } from 'redux/actions/useThunkActions'
import * as Api from 'redux/api/DataPlatform/shapes/sourceSchemas/v2'

import * as actions from 'redux/actions/DataPlatform/sourceSchemas/v2/actions'

function tryGetSourceSchemas() {
  return (dispatch: Dispatch) => {
    dispatch(actions.getSourceSchemas())

    Api.getAll()
      .then((response: any) => {
        dispatch(actions.getSourceSchemasSuccess(response.data.data))
      })
      .catch(() => {
        dispatch(actions.getSourceSchemasFailed())
      })
  }
}

export const useSourceSchemaActions = () => {
  return {
    tryGetSourceSchemas: useThunkActions(tryGetSourceSchemas)
  }
}
